import { post, get } from '../api/base';
import httpClient from '../api/interceptors/httpClient';
import { SERVER_URL } from './config';
import { ITC_ADMIN_ROLE_ID } from './PndConstants';
const EndPoint = SERVER_URL;

export default {

    /********************************** User Service ***************************************/
    /******* Login API */
    Login: (data) => {
        const params = {};
        return post(EndPoint + "auth/login", data, { params });
    },

    /****** Log Out API */

    Logout: () => {
        const params = {};
        const headers = {
            'Authorization': `Bearer ${(localStorage.getItem("refresh_token"))}`,
        };
        return httpClient.get(EndPoint + "auth/logout", { headers, params });
    },

    /** Refresh Token */
    GetRefreshToken: () => {
        const headers = {
            'Authorization': `Bearer ${(localStorage.getItem("refresh_token"))}`,
        };
        const params = {};
        return get(EndPoint + "auth/token/refresh", { headers, params });
    },
    /** profile**/
    GetProfileInformation: () => {
        const params = {};
        return httpClient.get(EndPoint + "user/profile", { params });
    },

    UnlockedHubUserAccount: (id) => {
        const params = {};
        return httpClient.get(EndPoint + "user/unlockedHubUserAccount/" + id, { params });
    },


    GetAllMobileAppVersion: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getAllMobileAppVersion', { params });
    },
    AddOrUpdateMobileAppVersion: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'user/addOrUpdateMobileAppVersion', data, { params });
    },
    /** reset the current password, if they forgot  the password */
    ResetPassword: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'user/resetPassword', data, { params }); /**  Hub User Reset */
    },

    /*Com Server*/
    GetComServerConfiguration: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getComServerConfiguration', { params });
    },
    GetSubscriptionDetailsByCustomerId: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getSubscriptionDetailsByCustomerId', { params });
    },


    GetSubscriptionAndPaymentPlan: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getSubscriptionAndPaymentPlan', { params });
    },

    UpdateComServerConfiguration: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'user/updateComServerConfiguration', data, { params });
    },

    GetAllHubOperators: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getAllHubOperators', { params });
    },

    GetAllInformapClientDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getAllInformapClientDetails', { params });
    },

    GetAllInformapClientForAdminCreation: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getAllInformapClientForAdminCreation', { params });
    },

    AddOrUpdateUserDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + "user/addOrUpdateUserDetails", data, { params });
    },


    AddOrUpdateInformapClientDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'user/addOrUpdateInformapClientDetails', data, { params });
    },

    ChangePassword: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'user/changePassword', data, { params }); /**  Hub User Reset */
    },

    ChangeRiderPassword: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/resetRiderPassword', data, { params });
    },

    /** Merchant Users */
    GetMerchantUsers: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getMerchantUsers', { params });
    },
    GetClientUsers: () => {//confusion
        const params = {};
        if (localStorage.getItem("uri") != ITC_ADMIN_ROLE_ID)
            return httpClient.get(EndPoint + 'user/getUsers', { params });
        else {
            return httpClient.get(EndPoint + 'user/getClientUsers', { params });
        }

    },
    UnlockedMerchantUserAccount: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'user/unlockedMerchantUserAccount/' + id, { params });
    },



    AddOrUpdateMerchantUserDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + "user/addOrUpdateMerchantUserDetails", data, { params });
    },

    /** FAQ */
    AddOrUpdateFaqData: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'user/addOrUpdateFaq', data, { params });
    },
    GetAllFaqDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getAllFaqDetails', { params });
    },
  GetAllFaqDetailsByType: (type) => {
        const params = {};
        return httpClient.get(EndPoint + 'user/getAllFaqDetailsByType/'+type, { params });
    },

    
    /***  HUB SERVICES */

    GetAllHubDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'hub/getAllHubDetails', { params });
    },


    GetAllActiveHub: () => {
        const params = {};
        return httpClient.get(EndPoint + 'hub/getAllActiveHub', { params });
    },
    GetHubById: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'hub/getHubById/' + id, { params });
    },


    AddOrUpdateHubDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'hub/addOrUpdateHubDetails', data, { params });
    },

    /** Shift */
    GetAllShiftType: () => {
        const params = {};
        return httpClient.get(EndPoint + 'hub/getAllShiftType', { params });
    },
    AddOrUpdateShiftType: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'hub/addOrUpdateShiftType', data, { params });
    },
    GetAllHubDutyShiftConfig: () => {
        const params = {};
        return httpClient.get(EndPoint + 'hub/getAllHubDutyShiftConfig', { params });
    },

    GetAllHubDutyShiftConfigByCustomerIdAndHubId: () => {
        const params = {};
        return httpClient.get(EndPoint + 'hub/getAllHubDutyShiftConfigByCustomerIdAndHubId', { params });
    },
    AddOrUpdateHubDutyShiftConfig: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'hub/addOrUpdateHubDutyShiftConfig', data, { params });
    },

    CheckDutyShiftConfigured: (id, id1) => {
        const params = {};
        return httpClient.get(EndPoint + 'hub/checkDutyShiftConfigured/' + id + "/" + id1, { params });
    },
    /************************************************** Rider Vehicle Service ************************************************* */

    /** Leased Rider Agency */
    GetAllDriverEmployer: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllDriverEmployer', { params });
    },
    AddOrUpdateDriverEmployer: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/addOrUpdateDriverEmployer', data, { params });
    },
    /** Diver */

    GetAllDriver: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllDriverDetails', { params });
    },
 GetAllDriverDetailsByCustomerId: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllDriverDetailsByCustomerId/'+id, { params });
    },
    

    GetAllHubAssignedDriverDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllHubAssignedDriverDetails', { params });
    },

    GetAllFreeRidersDetails: (id, selectedHubId) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllFreeRidersDetails/' + id + "/" + selectedHubId, { params });
    },

    GetAllFreeRidersDetailsForOrderTransfer: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllFreeRidersDetailsForOrderTransfer', { params });
    },

    GetAllAssignedDriverDetails: (isSelectedHubId) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllAssignedDriverDetails/' + isSelectedHubId, { params });
    },

    UnAssignDriverFromHub: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/unAssignDriverFromHub', data, { params });
    },

    AssignDriverToHub: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/assignDriverToHub', data, { params });
    },
    DeleteDriverDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/deleteDriver', data, { params });
    },
    AddOrUpdateDriver: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/addOrUpdateDriver', data, { params });
    },
    UnlockedRiderAccount: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/unlockedRiderAccount/' + id, { params });
    },

    AssignUnAssignVehicleToRider: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/assignUnAssignVehicleToRider', data, { params });
    },

    GetAllRiderDutyRoaster: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllRiderDutyRoaster', { params });
    },
    GetAllRiderDutyRoasterHistory: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllRiderDutyRoasterHistory', { params });
    },

    GetAllRidersDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllRidersDetails', { params });
    },
    FindRiderLiveGridViewData: (selectedHubId) => {
        if (selectedHubId == null || selectedHubId === '' || selectedHubId === 'null') {
            selectedHubId = -1;
        }
        const params = {};
        return httpClient.get(EndPoint + 'rider/findRiderLiveGridViewData/' + selectedHubId, { params });
    },
    getAllRiderDetailsByHubId: (hubId) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllRiderDetailsByHubId/' + hubId, { params });
    },

    GetAllOnDutyRidersDetails: () => {
        const params = {

        };
        return httpClient.get(EndPoint + 'rider/getAllOnDutyRidersDetails', { params });
    },

    GetRiderDutyRoasterById: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getRiderDutyRoaster/' + id, { params });
    },


    GetRiderLiveLocation: (id, value) => {
        const data = {
            riderStatusId: id,
            onBreak: value
        };
        const params = {};
        return httpClient.post(EndPoint + 'rider/getRiderLiveMap', data, { params });

    },

    /** Device Services */

    GetAllDeviceDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllDeviceDetails', { params });
    },

    UpdateLicenceDetails: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/updateLicenseKey/' + id, { params });
    },
    GetLicenseCancellationLog: (riderId, customerId) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getLicenseCancellationLog/' + riderId + '/' + customerId, { params });
    },
    /** Vehicle Details */

    GetAllVehicleDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllVehicleDetails', { params });
    },
    GetAllUnAssignedVehicleDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllUnAssignedVehicle', { params });
    },

    GetAllHubVehicleDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllHubAssignedVehicleDetails', { params });
    },
    GetAllDefaultVehicleDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getAllVehicleDefaultData', { params });
    },
    GetVehicleModal: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getVehicleModal/' + id, { params });
    },

    AddOrUpdateVehicleDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/addOrUpdateVehicleDetails', data, { params });
    },
    AssignVehicleToHub: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/assignVehicleToHub', data, { params });
    },
    /** Rider Roaster */

    SaveRiderRoasterData: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/saveRiderRoasterData', data, { params });
    },

    UpdateRiderRoasterData: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/updateRiderRoasterData', data, { params });
    },


    GroupUpdateRiderAvailabilityStatus: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/groupUpdateRiderAvailabilityStatus', data, { params });
    },

    UpdateRiderAvailabilityStatus: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/updateRiderAvailabilityStatus', data, { params });
    },
    UploadRiderRoasterData: (formData) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/uploadRiderRosterData', formData, { params });
    },
    RiderDutyExtensionApproval: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'rider/riderDutyExtensionApproval', data, { params });
    },
    GetRidersLocationHistory: (data) => {
        const params = {
            page: data?.page !== undefined ? data.page : 0,
            size: data?.size !== undefined ? data.size : 1000
        };
        return httpClient.post(EndPoint + 'rider/getRidersLocationHistory', data, { params });
    },

    /**************************************** Order Service *********************************************************/

    /** Delvery Rate Config */

    GetAllDeliveryAreaRateDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllDeliveryAreaRateDetails', { params });
    },
    GetDeliveryAreaRateById: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getDeliveryAreaRateById/' + id, { params });
    },
    AddOrUpdateDeliveryAreaRateDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateDeliveryAreaRateDetails', data, { params });
    },


    /*** Merchant */
    GetAllMerchantDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllMerchantDetails', { params });
    },
    AddOrUpdateMerchantDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateMerchantDetails', data, { params });
    },
    GetAllMerchantHubMappingDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllMerchantHubMappingDetails', { params });
    },
    UnAssignMerchantFromHub: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/unAssignMerchantFromHub', data, { params });
    },

    GetMerchantAssignedHub: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getMerchantAssignedHub', { params });
    },

    GetCustomerDeliveryTags: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getCustomerDeliveryTags', { params });
    },

    AddOrUpdateCustomerDeliveryTagMapping: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateCustomerDeliveryTagMapping', data, { params });
    },


    GetRiderWiseActiveOrderList: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getRiderWiseActiveOrderList/' + id, { params });
    },
    GetCustomerTagMapDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getCustomerTagMapDetails', { params });
    },


    GetOrderPreferencesByCustomerId: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderPreferencesByCustomerId', { params });
    },


    GetOrderPreferences: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderPreferences', { params });
    },
    UpdateOrderPreferences: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateOrderPreferences', data, { params });
    },

    GetAssignedOrderByRiderId: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAssignedOrderByRiderId/' + id, { params });
    },
    AssignMerchantFromHub: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/assignMerchantToHub', data, { params });
    },
    DeleteMerchant: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/deleteMerchant', data, { params });
    },
    ProcessOrderTransfer: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/processOrderTransfer', data, { params });
    },

    GetAllPickUpPointsDetails: (id) => { //merchant
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllPickupPointDetails/' + id, { params });
    },

    GetAllHubPickUpPointsDetails: () => { //hub
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllHubPickupPointDetails', { params });
    },
    AddOrUpdateMerchantPickUpPoint: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateMerchantPickUpPoint', data, { params });
    },

    AddOrUpdateHubPickUpPoint: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateHubPickUpPoint', data, { params });
    },

    /*** Teritorry */
    GetAllTerritoryDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllTerritoryDetails', { params });

    },
    GetAllTerritoryRegionAreaDetails: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllTerritoryRegionAreaDetails/' + id, { params }); //id-regionId
    },
    GetAllEmiratesDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllEmiratesDetails', { params });
    },

    GetStateWiseAreas: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllStateWiseAreaDetails/' + id, { params }); //id- emirate id/state id
    },
    AddOrUpdateTerritory: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateTerritory', data, { params });
    },

    /* updating Territory Area */

    UpdateTerritoryAreas: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/updateTerritoryAreas', data, { params });
    },

    /** Hub Customer */

    AddOrUpdateHubCustomer: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateHubCustomer', data, { params });
    },

    AddOrUpdateHubCustomerAddressBook: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateHubCustomerAddressBook', data, { params });
    },

    GetAllHubCustomers: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllHubCustomers', { params });
    },

    GetAllHubCustomerAddressBook: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllHubCustomerAddressBook', { params });
    },

    GetAllMerchantCustomerAddressBook: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllMerchantCustomerAddressBook', { params });
    },
    GetHubCustomerById: (id) => {  //id- hubcustomerid
        const params = {};
        return httpClient.get(EndPoint + 'order/getHubCustomerById/' + id, { params });
    },
    GetHubCustomerAddressBook: (id) => {//id- hubcustomerid
        const params = {};
        return httpClient.get(EndPoint + 'order/getHubCustomerAddressBook/' + id, { params });
    },
    /**** Merchant Customer */
    GetAllMerchantCustomers: (id) => { //merchantId
        const params = {};
        return httpClient.get(EndPoint + 'order/getAllMerchantCustomers/' + id, { params });
    },
    AddOrUpdateMerchantCustomer: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateMerchantCustomer', data, { params });
    },
    GetMerchantCustomerById: (id, id1) => { //id- merchant id, id1- customer id
        const params = {};
        return httpClient.get(EndPoint + 'order/getMerchantCustomerById/' + id + "/" + id1, { params });
    },
    GetMerchantCustomerAddressBook: (id) => {//id- merhcantcustomerid
        const params = {};
        return httpClient.get(EndPoint + 'order/getMerchantCustomerAddressBook/' + id, { params });
    },

    AddOrUpdateMerchantCustomerAddressBook: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateMerchantCustomerAddressBook', data, { params });
    },
    GetMerchantById: (id) => { //id- merchant customer id
        const params = {};
        return httpClient.get(EndPoint + 'order/getMerchantById/' + id, { params });
    },


    GetAllOrders: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/getAllOrders', data, { params });
    },

    GetSecurityOrderList: ({ operationalStatus, OPERATIONAL_STATUS_SECURITY_ORDER_LIST, OPERATIONAL_STATUS_SECURITY_HISTORY_LIST, page = 0, size = 10 } = {}) => {
        const opStatus = operationalStatus !== undefined ? operationalStatus : (OPERATIONAL_STATUS_SECURITY_ORDER_LIST !== undefined ? OPERATIONAL_STATUS_SECURITY_ORDER_LIST : OPERATIONAL_STATUS_SECURITY_HISTORY_LIST);
        const params = { page, size };
        return httpClient.get(EndPoint + 'order/getSecurityOrderList/' + opStatus, { params });
    },


    GetUndeliveredOrderDetails: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getUndeliveredOrderDetails', { params });
    },

    /** Reassign */
    GetAllAssignedOrders: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/getAllAssignedOrders', data, { params });
    },

    ProcessOrderReassignment: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/processOrderReassignment', data, { params });
    },

    UnassignOrderFromRider: (data = {}) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/unassignOrderFromRider', data, { params });
    },
    getOrderByIdById: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderById/' + id, { params });
    },

    getOrderDeclinedReasons: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderDeclinedReasons', { params });
    },

    getDeclineAttachments: (orderId, orderDeclinedId = null) => {
        const params = {};
        // if (orderDeclinedId !== null && orderDeclinedId !== undefined) {
        //     params.orderDeclinedId = orderDeclinedId;
        // }
        return httpClient.get(EndPoint + 'order/getDeclineAttachments/' + orderId + '/' + orderDeclinedId, { params });
    },

    securityApprovalProcess: (data, files = []) => {
        const params = {};
        const formData = new FormData();

        // Append the DTO as a JSON Blob under the key "data"
        // Backend expects: @RequestPart("data") SecurityApprovalProcessRequestDTO
        const jsonBlob = new Blob([JSON.stringify(data)], { type: 'application/json' });
        formData.append('data', jsonBlob);

        // Append image files under the key "images"
        // Backend expects: @RequestPart(value = "images", required = false) List<MultipartFile>
        if (files && files.length > 0) {
            files.forEach((file, index) => {
                formData.append('images', file, file.name || `proof_${index}.jpg`);
            });
        }

        // Do NOT set Content-Type manually — Axios sets multipart/form-data with correct boundary automatically
        return httpClient.post(EndPoint + 'order/securityApprovalProcess', formData, { params });
    },

    GetOrderItemWiseDetails: (id) => { //orderId
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderItemWiseDetails/' + id, { params });
    },

    GetAllCancelledOrders: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/getAllCancelledOrders', data, { params });
    },
    GetAllWithdrewOrders: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/getAllWithdrewOrders', data, { params });
    },
    GetPunchedOrdersDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/getPunchedOrdersDetails', data, { params });
    },
    GetOrderHistory: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/getOrderHistory', data, { params });
    },



    // GetOrderHistory: (data, page = 0, size = 10) => {
    //     const params = { page, size };
    //     return httpClient.post(EndPoint+ 'order/getOrderHistory', data, { params });
    // },

    GetRejectedItemDetails: (orderId) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getRejectedItemDetails/' + orderId, { params });
    },
    GetTripHistory: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/getTripHistory', data, { params });
    },
    GetPickUpPointGeoData: () => {
        const params = {};
        return httpClient.get(EndPoint + 'rider/getPickUpPointGeoData', { params });
    },


    AddorUpdateOrderDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/addOrUpdateOrders', data, { params });
    },

    ReturnOrderStatusUpdate: (id) => { //orderId
        const params = {};
        return httpClient.get(EndPoint + 'order/returnOrderStatusUpdate/' + id, { params });
    },
    GetAllOrderRemarksByOrderId: (id) => {//orderId
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderRemarksByOrderId/' + id, { params });
    },
    UpdateOrderRemarks: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/updateOrderRemarks', data, { params });
    },


    CheckOrderAssignedToRider: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/checkOrderAssignedToRider', data, { params });
    },

    UpdateOrderStatusDetails: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/updateOrderStatus', data, { params });
    },
    OrderBulkAssignmentProcess: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/orderBulkAssignmentProcess', data, { params });
    },
    GetOrderProcessedStatus: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderProcessedStatus/' + id, { params });
    },

    DeleteCustomerTagMapping: (mapId) => {
        const params = {};
        return httpClient.post(EndPoint + 'order/deleteCustomerDeliveryTagMap/' + mapId, { params });
    },
    GetOrderAttachmentCount: (id) => {
        const params = { "orderId": id };
        return httpClient.get(EndPoint + 'order/getOrderAttachment', { params });
    },

    GetOrderWiseAddressInformation: (id) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getOrderWiseAddressInformation/' + id, { params });
    },

    /***** Tracking URL**/

    GetRiderLiveTracking: (data) => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getRiderTracking/'+ data,  { params });
    },
//*** ORDER***/
    GetAllChatHistoryByRiderId: (receiverId, receiverType) => {
        const params = {
            receiverId: receiverId,
            receiverType: receiverType
        };
        return httpClient.get(EndPoint + "chat/getSupportChatHistoryByReceiverAndType", { params });
    },

    saveChatData: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'chat/saveMessage', data, { params });
    },

    /***************************************************** COMMON ****************************************************************** */
    GetDashBoardData: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'common/getDashboardData', data, { params });
    },
    GetSecurityDashboardStats: () => {
        const params = {};
        return httpClient.get(EndPoint + 'order/getSecurityDashboardStatistics', { params });
    },
    /***************************************************** Report ****************************************************************** */


    GetPndStatisticalSummaryReport: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/getPndStatisticalSummaryReport', { params });
    },


    GenerateRiderDutyReport: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateRiderDutyReport', data, { params });
    },

    GenerateRiderActivitySummaryReport: () => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateRiderActivitySummaryReport', { params });
    },
    GenerateOrderSummaryReport: () => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateOrderSummaryReport', { params });
    },

    GenerateOrderPerformanceReport: () => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateOrderPerformanceReport', { params });
    },

    GenerateOrderDetailsReport: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateOrderDetailsReport', data, { params });
    },

    GenerateOrderReport: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateOrderReport', data, { params });
    },

    GenerateOTRReport: (payload) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateOTRReport', payload, { params });
    },

    GenerateOTRIntervalReport: () => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateOTRIntervalReport', { params });
    },
    GenerateSecurityPerformanceReport: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateSecurityPerformanceReport', data, { params });
    },
    GenerateComplianceDeliveryReport: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/generateComplianceDeliveryReport', data, { params });
    },
    GenerateOrderFailedReport: (data) => {
        const params = {};
        return httpClient.post(EndPoint + 'report/getFailedOrders', data, { params });
    },




    /***************************************************** Notification ****************************************************************** */

    GetNotificationHistory: () => {
        const params = {
            category: 4 //Web notification
        };
        return httpClient.get(EndPoint + 'notification/getNotificationHistory', { params });
    },
    UpdateNotificationReadStatus: (id) => {
        const params = {};
        //     notificationId: id 
        // };
        return httpClient.put(EndPoint + 'notification/markReadNotification/' + id, { params });
    },
};